module.exports = __webpack_public_path__ + "static/media/天賦基因套餐_採樣視頻.35e36d2.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/天賦基因套餐_採樣視頻.mp4
// module id = hY0J
// module chunks = 0